import React from 'react';
import portfolio3 from '../../Images/portfolio3pro.png';
import './About.css';

const About = () => {
    return (
        <section className='mt-5 pt-5 bg-dark bg-opacity-50' id='about'>
            <div className='container'>
                <h1 className='text-center text-warning'>About Me</h1>
                <div className="small-border mb-4"></div>
                <div className='row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6' data-aos="fade-right" data-aos-duration="2000">
                        <img src={"https://i.ibb.co/b2tc5Dk/IMG-20230210-WA0006-1-1-removebg-preview.png"} alt="pic" className='img-fluid w-75 handleImgwidth' />
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6' data-aos="fade-left" data-aos-duration="2000">
                        <div className='mt-5 text-light'>
                            <h3 style={{ color: "khaki" }}>Hi There</h3>
                            <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>This Md. Saimon Sikder Srayo, You can call me Srayo, I am a full-stack developer. Specially MERN Developer. What you know about me, I put the some answer below, You may like it.</p>
                            <div className='row pt-3'>
                                <div className='col'>
                                    <h3 style={{ color: "khaki" }}>Name:</h3>
                                    <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>Md. Saimon Sikder Srayo</p>
                                    <h3 style={{ color: "khaki" }}>Phone:</h3>
                                    <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>+8801873943047</p>
                                </div>
                                <div className='col'>
                                    <h3 style={{ color: "khaki" }}>Email:</h3>
                                    <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>srayosikder@gmail.com</p> {window.innerWidth < 462 && <br />}
                                    <h3 style={{ color: "khaki" }}>GitHub:</h3>
                                    <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>https://github.com/srayo16</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default About;